export const environment = {
    production: false,
    api: {
        baseUrl: 'https://backenddev.windowadvertising.co/',
    },
    firebaseConfig: {
        apiKey: "AIzaSyDp7Qhcq6gVJ4dNvYMJTlhmUBNUFXJXLq4",
        authDomain: "onstore-public.firebaseapp.com",
        projectId: "onstore-public",
        storageBucket: "onstore-public.firebasestorage.app",
        messagingSenderId: "516189444570",
        appId: "1:516189444570:web:8763b25a0f48c4d4e288e3",
        measurementId: "G-MJ0ZJJ5WY3",
        vapidKey: "BGZnYHFqTYQof4DisNhl_pUUEHGyi_qmS0DMaeGgYiOp0Mgwzqr1J04ZQRM_hI30K8VP1FMryqC3lYWKlPLiFSU"
    },
    cloudinary: {
        cloudName: 'dbqufebj4',
        apiKey: '139137765558177',
        apiSecret: 'hsOg-ldjplTC5oOpwT_Pdig1Fgg'
    },
    google: {
        places: {
            baseUrl: 'https://maps.googleapis.com/maps/api/place/',
            fromTextSearch: 'findplacefromtext/json?fields=formatted_address%2Cname&inputtype=textquery',
            apiKey: 'AIzaSyCrCKho0NqKUCuO5PeTw-w7azAQWqIdLyA'
        },
        map: {
            id: 'e2457477056dfdac'
        }
    },
    cloudinaryUrl: "https://api.cloudinary.com/v1_1",
    googleMapAPIKey:"AIzaSyCrCKho0NqKUCuO5PeTw-w7azAQWqIdLyA",
    api_key: '87c1c967b2aa47cc9befdbee44522023',
    s3_bucket: {
        bucketName: 'onstore-dev-artworks',
        AWS_REGION: 'us-west-1'
    },
    hmac: {
        secretKey: '092013377e97446f4ef0cba125dbed538288fd86e09799bf2672888901fe5631'
    },
    artwork: {
        templateZipUrl: 'https://onstore-dev-artworks.s3.us-west-1.amazonaws.com/public-assets/AI+Templates.zip',
        instructionPdfUrl: 'https://onstore-dev-artworks.s3.us-west-1.amazonaws.com/public-assets/Artwork+Submission+Requirements.pdf',
        banner: 'https://onstore-client-artwork-templates.s3.amazonaws.com/01+Banner+300x60.zip',
        landscape: 'https://onstore-client-artwork-templates.s3.amazonaws.com/04+Landscape+108x72.zip',
        square: 'https://onstore-client-artwork-templates.s3.amazonaws.com/03+Square+96x96.zip',
        portrait: 'https://onstore-client-artwork-templates.s3.amazonaws.com/02+Portrait+48in+x+120in.zip'
    }
}
